import * as React from 'react';
import { SVG } from '../../Utils/SVG';
const closeIconURL = require('../../../icons/cross.svg');
import './style.css';

export interface DialogProps {
  dialogClassName?: string;
  title: string;
  onClose: () => void;
}

export interface DialogState {
  /* empty */
}

let id = 0;

export class Dialog extends React.Component<DialogProps, DialogState> {
  private elementId: string = `eop-dialog-${id++}`;
  private maskRef: React.RefObject<HTMLDivElement>;

  constructor(props: DialogProps) {
    super(props);

    this.maskRef = React.createRef();
  }

  render() {
    const { wrapClassName } = this;
    const { children, dialogClassName: className, onClose, title } = this.props;
    const labelId = `${this.elementId}-label`;
    const descriptionId = `${this.elementId}-description`;

    return (
      <div
        className={wrapClassName(className, `mask`)}
        ref={this.maskRef}
        onClick={this.handleMaskClick}
      >
        <div className={wrapClassName(className, `container`)}>
          <div
            id={this.elementId}
            className={wrapClassName(className)}
            role="dialog"
            aria-labelledby={labelId}
            aria-describedby={descriptionId}
            aria-modal="true"
          >
            <h2 id={labelId} className={wrapClassName(className, `heading`)}>
              {title}
            </h2>
            <button
              className={wrapClassName(className, `close-button`)}
              onClick={onClose}
            >
              <SVG
                className={wrapClassName(className, `close-icon`)}
                src={closeIconURL}
              />
            </button>
            <section
              id={descriptionId}
              className={wrapClassName(className, `content`)}
            >
              {children}
            </section>
          </div>
        </div>
      </div>
    );
  }

  private handleMaskClick = (event: React.MouseEvent<HTMLDivElement>): void => {
    const target = event.target as Element;

    if (target === this.maskRef.current) {
      // Fire our close handler if the mask itself is clicked
      this.props.onClose();
    }
  };

  /**
   * Returns a suitable set of classNames based on the presence of a custom className
   * and a classNameSuffix.
   * @example
   * ```
   * wrapClassName('custom-dialog');            => "eop-dialog custom-dialog"
   * wrapClassName('custom-dialog', 'content'); => "eop-dialog-content custom-dialog-content"
   * wrapClassName(undefined, 'mask');          => "eop-dialog-mask"
   * ```
   */
  private wrapClassName(
    customClassName?: string,
    classNameSuffix?: string
  ): string {
    const actualClassNameSuffix = classNameSuffix ? `-${classNameSuffix}` : ``;
    const fullDefaultClassName = `eop-dialog${actualClassNameSuffix}`;
    const fullCustomClassName = `${
      customClassName ? ` ${customClassName}${actualClassNameSuffix}` : ``
    }`;

    return `${fullDefaultClassName}${fullCustomClassName}`;
  }
}

export default Dialog;



// WEBPACK FOOTER //
// ./src/app/components/Common/Dialog/index.tsx